import useUserContext from 'Context/UserContext';
import useHomeContext from 'Context/HomeContext';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import fr from 'facet-rest';
import { navigateTo } from 'Helpers/Redirect';
import history from 'State/history';

export const UserLayout = () => {
  const { updateUserResource } = useUserContext();
  const { refreshHomeResource } = useHomeContext();

  useComponentDidMount(async () => {
    const home = await refreshHomeResource();
    const [userResource] = await home.withRelationship(
      fr.relationships.user.name,
      (rel) => rel.link('related').get(),
      () => [],
    );
    if (userResource) {
      updateUserResource(userResource);
    }

    // Sometimes, the login URL will contain a 'to' query param that determines where
    // the user should be directed to after successful login.  Check for that here.  If
    // it exists, go there.  Otherwise, go to the root path.
    const url = new URL(window.location.href);
    const redirectTo = url.searchParams.get('to');
    if (redirectTo) {
      history.replace(decodeURI(redirectTo));
    } else {
      navigateTo('/');
    }
  });

  return null;
};
